import { TestsheetStatus } from '@services';
import { GrFormCheckmark } from 'react-icons/gr';
import { IoIosSend } from 'react-icons/io';
import { RiHourglassFill } from 'react-icons/ri';

export const TestsheetStatusProvider = ({ status }: { status: TestsheetStatus }) => {
    switch (status) {
        case TestsheetStatus.TO_VALIDATE:
            return (
                <div className="testsheet-item-created">
                    <RiHourglassFill fontSize={28} color="#B3E0CA" />
                </div>
            );
        case TestsheetStatus.TO_ARCHIVE:
            return (
                <div className="testsheet-item-created">
                    <IoIosSend fontSize={28} color="#B3E0CA" />
                </div>
            );
        case TestsheetStatus.ARCHIVED:
            return (
                <div className="testsheet-item-confirmed">
                    <GrFormCheckmark fontSize={28} color="white" />
                </div>
            );
        default:
            return <div className="testsheet-item-status">Inconnue</div>;
    }
};
